var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "elementType": "li",
      "customClass": ['tab-' + _vm.tab.name, {
        active: _vm.activeTab === _vm.tab.name
      }, {
        deactivated: _vm.disabledTab(_vm.tab) || _vm.rayTracerDisabled
      }, {
        hide: _vm.hideTab(_vm.tab)
      }]
    },
    on: {
      "click": function click($event) {
        return _vm.changeTab(_vm.tab);
      }
    }
  }, [_c('a', {
    staticClass: "tab-name organism",
    attrs: {
      "id": _vm.tab.name
    }
  }, [_vm.tab.tooltip ? _c('tab-tooltip', {
    attrs: {
      "tooltip": _vm.tab.tooltip,
      "customsClasses": "swatches-view-v-popover ugc-tooltip-data"
    }
  }) : _vm._e(), _c('tab-upcharge', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.tab.name === 'add-your-own',
      expression: "tab.name === 'add-your-own'"
    }]
  }), _vm._v("\n     " + _vm._s(_vm.tab.display_name) + "\n    "), _vm.tab.icon ? _c('tab-icon', {
    attrs: {
      "customClass": "icon-".concat(_vm.tab.icon_name),
      "icon": _vm.tab.icon
    }
  }) : _vm._e(), !_vm.tab.title_only && _vm.swatchesCount > 0 ? _c('CustomText', {
    attrs: {
      "customClass": "configurator-swatch-count",
      "elementType": "span",
      "text": "(".concat(_vm.swatchesCount, ")")
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }